module.exports = __webpack_public_path__ + "img/sidebar-battery-3.b04cad3a.svg";